<template>
    <div
        @click="$emit('clickaccion')"
        style="cursor:pointer"
    >
        <v-snackbar
            :value="value"
            right
            :bottom="true"
            :timeout="timeSuccess"
            :color="colorMessage"
            content-class="c-sms-action"
        >
            <div class="d-block">
                <h1
                    class="app-private-title-dark mt-1"
                    v-for="(text, index) in smsAction"
                    :key="index"
                >{{text}}</h1>
            </div>
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        value: Boolean,
        smsAction: Array,
        colorMessage: {
            default: "success",
            type: String
        },
        timeSuccess: Number
    }
}
</script>
